// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iK","header":"iL","subHeader":"iM","button":"iN","actionLinks":"iO","actionLink":"iP","actionText":"iQ"};